/**
 * Turns a table into stacked cards on phones (<768px): every cell gets data-label from its column header,
 * the CSS in mobileCards.css shows «label: value» rows and hides the header.
 * Usage: <table class="table" v-mobile-cards>…</table>
 * Cells with data-label="" (e.g. checkboxes, action buttons) are shown without a label.
 */
function label(table) {
  const headers = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
  if (!headers.length) return;
  for (const row of table.querySelectorAll('tbody tr')) {
    let column = 0;
    for (const cell of row.children) {
      if (!cell.hasAttribute('data-label-fixed')) {
        cell.setAttribute('data-label', headers[column] || '');
      }
      column += Number(cell.getAttribute('colspan') || 1);
    }
  }
}

export default {
  mounted(el) {
    el.classList.add('mobile-cards');
    label(el);
  },
  updated(el) {
    label(el);
  },
};
